import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { TextInputField } from 'common/components/form_fields';

const RemoveAccountForm = ({error, handleSubmit, submitting, submitFailed, onCancel, user}) => (
  <form onSubmit={handleSubmit}>
    <Field name="confirmation" label="Delete Account" component={TextInputField} />
    <div className="modal-actions">
      <AnimatedButton processing={submitting} label="Yes, Permanently Delete My Account" onClick={handleSubmit}
        processingLabel="Deleting..." errorMsg={error || submitFailed}
        successMsg="Account Deleted."/>
      <button className="btn btn-text" onClick={(e) => {e.preventDefault(); onCancel();}}>
        No! Get me outta here.
      </button>
    </div>
  </form>
)

const validate = values => {
  if (values['confirmation'] != "DELETE")
    return {confirmation: 'Confirmation does not match'}
  return {}
}

export default reduxForm({
  form: "RemoveAccountForm",
  validate,
})(RemoveAccountForm);



// WEBPACK FOOTER //
// ./account/components/remove_account_form.jsx